import React, { Component } from 'react';
import { Row } from 'reactstrap';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import SortableList from '../components/sortable/SortableList';
import Content from '../components/layout/Content';
import Loading from '../components/Loading';

import { updateProductSortId } from '../api/product';
import { getCategoriesWithProducts, updateCategorySortId } from '../api/category';

class ProductSortable extends Component {
  constructor(props) {
    super(props);
    this.reorder = this.reorder.bind(this);
    this.onDragEnd = this.onDragEnd.bind(this);
    this.state = {
      loading: true,
    };
  }

  async componentDidMount() {
    const { user } = this.props;
    // const masterUser = user.isAdmin ? user.id : user.masterUserId;
    const masterUser = user && (user.masterUserId || user.id);
    const res = await getCategoriesWithProducts(masterUser);
    this.setState({ categories: res.data.categories, loading: false });
  }

  onDragEnd(result) {
    // dropped outside the list
    if (!result.destination) {
      return;
    }

    const { categories } = this.state;
    if (result.destination.droppableId.includes('-')) {
      const index = result.destination.droppableId.split('-')[1];
      const startCategory = result.source.droppableId.split('-')[1];
      const endCategory = result.destination.droppableId.split('-')[1];

      // if the categories are not same
      if (startCategory !== endCategory) {
        let startList = categories[startCategory].Products;
        let endList = categories[endCategory].Products;
        // Push startlist to endlist
        endList.push(startList[result.source.index]);
        // Filter selectedProduct from start list
        startList = startList.filter((product, orderIndex) => orderIndex !== result.source.index);
        // Reorder Start List
        startList = this.reorder(
          startList,
          result.source.index,
          result.source.index,
        );
        // Reorder End List
        endList = this.reorder(
          endList,
          endList.length - 1,
          result.destination.index,
        );
        // Change selected Product categoryId
        const selectedProduct = endList[result.destination.index];
        selectedProduct.categoryId = categories[endCategory].id;
        endList[result.destination.index] = selectedProduct;
        // Update State variable
        categories[startCategory].Products = startList;
        categories[endCategory].Products = endList;
        // Request to save changes
        updateProductSortId([startList, endList]);
        this.setState({ categories });
      } else {
        const list = categories[index].Products;
        const products = this.reorder(
          list,
          result.source.index,
          result.destination.index,
        );
        updateProductSortId([products]);
        categories[index].Products = products;

        this.setState({ categories });
      }
    } else {
      const list = categories;
      const newCategories = this.reorder(
        list,
        result.source.index,
        result.destination.index,
      );
      updateCategorySortId([newCategories]);

      this.setState({ categories: newCategories });
    }
  }

  reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    if (removed !== undefined) {
      result.splice(endIndex, 0, removed);
    }
    return result;
  }

  render() {
    const { categories, loading } = this.state;
    const { intl } = this.props;

    const titleText = intl.formatMessage({ id: 'productSorting.title' });
    return (
      <Content title={titleText}>
        {
          loading ? <Loading />
            : (
              <Row>
                {
                  <SortableList onDragEnd={this.onDragEnd} categories={categories} />
                }
              </Row>
            )

        }
      </Content>
    );
  }
}

ProductSortable.propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func,
  }).isRequired,
  user: PropTypes.shape({
    isAdmin: PropTypes.number,
    id: PropTypes.number,
    masterUser: PropTypes.oneOf([PropTypes.number, null]),
  }).isRequired,
};

const mapStateToProps = (state) => ({ user: state.auth.user });

export default injectIntl(connect(mapStateToProps)(ProductSortable));
